import { Helmet, HelmetProvider } from "react-helmet-async";
import HeaderFooterLayout from "../components/layouts/HeaderFooterLayout";
import styles from "./Mailings.module.css";
import Card from "../components/cards/Card";
import { useCallback, useEffect, useRef, useState } from "react";
import api from "../api";
import { formatDateV2, formatTimeV2, getMailStatusBadge } from "../utils";
import { MailingType, MailStatus } from "../common/constants";
import TooltipWrapper from "../components/TooltipWrapper";
import { useTranslation } from "react-i18next";
import StatusBadge from "../components/StatusBadge";
import MeatBallsMenu from "../components/MeatBallsMenu";
import { ReactComponent as SendIcon } from "../assets/images/icons/ic-send.svg"
import { ReactComponent as ClockIcon } from "../assets/images/icons/ic-clock.svg"
import { ReactComponent as CancelIcon } from "../assets/images/icons/ic-close.svg"
import { ReactComponent as EyeIcon } from "../assets/images/icons/ic-eye.svg"
import { ReactComponent as DeleteIcon } from "../assets/images/icons/ic-delete.svg"
import { ReactComponent as FilterIcon } from "../assets/images/icons/ic-filter.svg"
import TextInput from "../components/TextInput";
import Button from "../components/Button";
import Dialog from "../components/dialogs/Dialog";
import AlertDialog from "../components/dialogs/AlertDialog";
import MultipleSelect from "../components/MultipleSelect";
import Table from "../components/Table";
import EmptyContent from "../components/EmptyContent";
import Pagination from "../components/Pagination";
import useWindowDimensions from "../common/hooks/useWindowDimensions";

const Mailings = () => {

    const { width } = useWindowDimensions();
    const { t } = useTranslation();
    const [mailings, setMailings] = useState([]);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [per] = useState(25);
    const [filters, setFilters] = useState({
        type: [],
        status: [],
        q: null,
        date_from: '',
        date_to: '',
        date_field: 'created_at'
    });
    const [sendingMail, setSendingMail] = useState(null)
    const [cancellingMail, setCancellingMail] = useState(null)
    const [reschedulingMail, setReschedulingMail] = useState(null)
    const [viewMailContent, setViewMailContent] = useState(null)
    const [deletingMail, setDeletingMail] = useState(null)
    const [filterOpen, setFilterOpen] = useState(false)
    const [loadError, setLoadError] = useState('')
    const listRequest = useRef(0)
    const activeFilterCount = filters.type.length + filters.status.length + Number(Boolean(filters.date_from || filters.date_to));

    const mailTypes = [
        {
            id: 0,
            name: 'Candidatura Inviata',
            value: MailingType.ApplicationSent
        },
        {
            id: 1,
            name: 'Candidatura Accettata',
            value: MailingType.ApplicationApproved
        },
        {
            id: 11,
            name: 'Chiamata Effettuata',
            value: MailingType.InfoApproved
        },
        {
            id: 2,
            name: 'Candidatura Rifiutata',
            value: MailingType.ApplicationRejected
        },
        {
            id: 3,
            name: 'Benvenuto',
            value: MailingType.Welcome
        },
        {
            id: 4,
            name: 'Benvenuto Docente',
            value: MailingType.WelcomeTeacher
        },
        {
            id: 5,
            name: 'Benvenuto Admin',
            value: MailingType.WelcomeAdmin
        },
        {
            id: 6,
            name: 'Reset Password',
            value: MailingType.ResetPassword
        },
        {
            id: 7,
            name: 'Conferma Ordine',
            value: MailingType.OrderConfirmation
        },
        {
            id: 27,
            name: 'Conferma Ordine Education',
            value: MailingType.AdminOrderConfirmation
        },
        {
            id: 25,
            name: 'Regalo corso',
            value: MailingType.GiftCourse
        },
        {
            id: 8,
            name: 'Attivazione Voucher',
            value: MailingType.VoucherActivation
        },
        {
            id: 9,
            name: 'Richiesta di attestato',
            value: MailingType.CertificateRequest
        },
        {
            id: 10,
            name: 'Iscrizione al corso',
            value: MailingType.CourseSubscription
        },
        {
            id: 20,
            name: 'Invito aziendale',
            value: MailingType.CompanyInvite
        },
        {
            id: 12,
            name: 'Nuova Edizione Disponibile',
            value: MailingType.NewEdition
        },
        {
            id: 13,
            name: 'Edizione in arrivo',
            value: MailingType.UpcomingEdition
        },
        {
            id: 14,
            name: 'Edizione terminata',
            value: MailingType.EndedEdition
        },
        {
            id: 15,
            name: 'Rate in scadenza',
            value: MailingType.InstallmentsExpiring
        },
        {
            id: 16,
            name: 'Rate scadute',
            value: MailingType.InstallmentsExpired
        },
        {
            id: 17,
            name: 'Rata pagata',
            value: MailingType.InstallmentPaid
        },
        {
            id: 24,
            name: 'Fattura evasa',
            value: MailingType.InvoiceFulfilled
        },
        {
            id: 22,
            name: 'Link pagamento rata',
            value: MailingType.InstallmentPaymentLink
        },
        {
            id: 23,
            name: 'Promemoria checkout ordine',
            value: MailingType.PendingOrderCheckout
        },
        {
            id: 27,
            name: 'Richiesta correzione numero',
            value: MailingType.SalesPhoneCorrection
        },
        {
            id: 26,
            name: 'Personalizzata per edizione',
            value: MailingType.EditionCustom
        },
        {
            id: 18,
            name: 'Biglietto Evento',
            value: MailingType.EventTicket
        },
        {
            id: 19,
            name: 'Attività Evento',
            value: MailingType.EventActivity
        },
        {
            id: 21,
            name: 'Accredito Stampa Evento',
            value: MailingType.EventPressTicket
        }
    ]

    const mailStatus = [
        {
            id: 0,
            name: 'Bozza',
            value: 'draft'
        },
        {
            id: 1,
            name: 'Programmata',
            value: 'scheduled'
        },
        {
            id: 2,
            name: 'Inviata',
            value: 'sent'
        },
        {
            id: 3,
            name: 'Annullata',
            value: 'cancelled'
        },
        {
            id: 4,
            name: 'Errore',
            value: 'failed'
        }
    ]

    const getMailings = useCallback(async () => {
        const request = ++listRequest.current;
        setLoading(true);
        setLoadError('');
        if (filters.date_from && filters.date_to && filters.date_from > filters.date_to) {
            setMailings([]); setCount(0); setLoading(false);
            return;
        }
        try {
            const params = new URLSearchParams();

            params.append("page", page);
            params.append("per", per);

            if (filters.type.length > 0) {
                params.append("type", filters.type.join(","));
            }

            if (filters.status.length > 0) {
                params.append("status", filters.status.join(","));
            }
            if (filters.q) {
                params.append("q", filters.q);
            }

            if (filters.date_from) params.append('date_from', filters.date_from);
            if (filters.date_to) params.append('date_to', filters.date_to);
            if (filters.date_from || filters.date_to) params.append('date_field', filters.date_field);

            const data = await api.get(`/admin/mailings?${params.toString()}`);
            const { mailings, count } = data;

            if (request === listRequest.current) { setMailings(mailings); setCount(count); }
        } catch (e) {
            if (request === listRequest.current) {
                setMailings([]); setCount(0);
                setLoadError('Impossibile caricare le mail. Riprova.');
            }
        } finally {
            if (request === listRequest.current) setLoading(false);
        }
    }, [page, per, filters])

    const sendEmail = async (mail_id) => {
        try {
            let mail = await api.get(`/admin/mailings/${mail_id}/send`)
            setMailings(current => current.map(m => m.id === mail.id ? { ...m, ...mail } : m));
        }
        catch (e) {
            console.error(e)
        }
    }

    const cancelMail = async (mail_id) => {
        try {
            let mail = await api.get(`/admin/mailings/${mail_id}/cancel`)
            setMailings(current => current.map(m => m.id === mail.id ? { ...m, ...mail } : m));
        }
        catch (e) {
            console.error(e)
        }
    }

    const rescheduleEmail = async (mail) => {
        try {
            let rescheduled = await api.get(`/admin/mailings/${mail.id}/reschedule?date=${mail.reschedule_date}`)
            setMailings(current => current.map(m => m.id === rescheduled.id ? { ...m, ...rescheduled } : m));
        }
        catch (e) {
            console.error(e)
        }
    }

    const deleteEmail = async (mail_id) => {
        try {
            await api.delete(`/admin/mailings/${mail_id}`)
            if (mailings.length === 1 && page > 0) setPage(current => current - 1);
            else await getMailings();
        }
        catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(getMailings, 250);
        return () => { clearTimeout(timer); listRequest.current += 1; };
    }, [getMailings]);

    const dateCell = value => ({
        value: value ? new Date(value).getTime() : 0,
        type: 'number',
        component: <span className={styles.date}>{value ? `${formatDateV2(value, { day: 'numeric', month: 'short', year: 'numeric' })} · ${formatTimeV2(value)}` : '—'}</span>,
    });
    const rows = mailings.map(mail => {
        const badge = getMailStatusBadge(mail.status);
        const lastError = mail.status === MailStatus.Failed ? mail.errors?.[mail.errors.length - 1] : null;
        const statusBadge = <StatusBadge appearance="soft" label={badge.label} color={badge.color} />;
        return {
            id: mail.id,
            subject: { value: mail.subject, type: 'string', component: <div className={styles.subject}><button onClick={() => setViewMailContent(mail)}>{mail.subject || 'Senza titolo'}</button>{mail.attachments?.length > 0 && <span>{mail.attachments.length} allegati</span>}</div> },
            recipient: { value: mail.to, type: 'string', component: <div className={styles.recipient}>{mail.user?.id && <a href={`/users/students/${mail.user.id}`} target="_blank" rel="noreferrer">{mail.user.name} {mail.user.surname}</a>}<span>{mail.to}</span></div> },
            type: t(`mailing.type.${mail.type}`),
            created_at: dateCell(mail.created_at),
            sent_at: dateCell(mail.status === MailStatus.Sent ? mail.updated_at : null),
            scheduled_for: dateCell(mail.scheduled_for),
            status: { value: mail.status, type: 'string', component: lastError ? <TooltipWrapper text={`${lastError.created_at ? formatDateV2(lastError.created_at) + ' · ' : ''}${lastError.message}`}><div>{statusBadge}</div></TooltipWrapper> : statusBadge },
            actions: <MeatBallsMenu
                actions={mail.status !== MailStatus.Sent ? [
                    {
                        label: "Invia ora", icon: SendIcon, style: { color: "var(--sf-primary)", fontWeight: 500 }, onClick: () => {
                            setSendingMail(mail)
                        }
                    },
                    {
                        label: "Riprogramma", icon: ClockIcon, style: { color: "var(--sf-gray)", fontWeight: 500 }, onClick: () => {
                            setReschedulingMail(mail)
                        }
                    },
                    {
                        label: "Vedi contenuto", icon: EyeIcon, style: { color: "var(--sf-green)", fontWeight: 500 }, onClick: () => {
                            setViewMailContent(mail)
                        }
                    },
                    {
                        label: "Annulla", icon: CancelIcon, style: { color: "black", fontWeight: 500 }, onClick: () => {
                            setCancellingMail(mail)
                        }
                    },
                    {
                        label: "Elimina", icon: DeleteIcon, style: { color: "var(--sf-red)", fontWeight: 500 }, onClick: async () => {
                            setDeletingMail(mail)
                        }
                    }
                ] : [
                    {
                        label: "Invia di nuovo", icon: SendIcon, style: { color: "var(--sf-primary)", fontWeight: 500 }, onClick: () => {
                            setSendingMail(mail)
                        }
                    },
                    {
                        label: "Vedi contenuto", icon: EyeIcon, style: { color: "var(--sf-green)", fontWeight: 500 }, onClick: () => {
                            setViewMailContent(mail)
                        }
                    }
                ]} />,
        };
    });

    return (
        <HeaderFooterLayout>
            <HelmetProvider>
                <Helmet>
                    <title>Mail</title>
                </Helmet>
            </HelmetProvider>
            <div className={styles.container}>
                <div className={styles.section}>
                    <div className={styles.sectionInner}>
                        <header className={styles.header}>
                            <h1>Mail</h1>
                            <p>Consulta i messaggi, verifica gli invii e gestisci la programmazione.</p>
                        </header>
                        <Card appearance="modern" integratedTable title="Elenco mail" actions={<span className={styles.resultCount} role="status">{loading ? 'Caricamento…' : `${count} mail`}</span>}>
                            <div className={styles.search}>
                                <TextInput
                                    appearance="modern"
                                    value={filters.q}
                                    onKeyUp={(value) => {
                                        setPage(0);
                                        setFilters({
                                            ...filters,
                                            q: value
                                        })
                                    }}
                                    type="search"
                                    placeholder={t("search")} />
                                <Button appearance="subtle" additionalClass={styles.filterButton} aria-expanded={filterOpen} aria-controls="mail-filters" onClick={() => setFilterOpen(open => !open)}>
                                    <FilterIcon aria-hidden="true" /> Filtri{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
                                </Button>
                            </div>
                            <div id="mail-filters" className={styles.filters} hidden={!filterOpen}>
                                <div className={styles.filterField}><span>Tipo di mail</span><MultipleSelect appearance="modern" portal
                                    selected={mailTypes.filter(p => filters.type.includes(p.value))}
                                    options={mailTypes}
                                    allLabel="Tutti i tipi"
                                    placeholder="Tutti i tipi"
                                    onSelect={(items) => {
                                        setPage(0);
                                        setFilters({
                                            ...filters,
                                            type: items.map(item => item.value)
                                        })
                                    }} /></div>
                                <div className={styles.filterField}><span>Stato</span><MultipleSelect appearance="modern" portal
                                    selected={mailStatus.filter(s => filters.status.includes(s.value))}
                                    options={mailStatus}
                                    placeholder="Tutti gli stati"
                                    allLabel="Tutti gli stati"
                                    onSelect={(items) => {
                                        setPage(0);
                                        setFilters({
                                            ...filters,
                                            status: items.map(item => item.value)
                                        })
                                    }} /></div>
                                <label className={styles.filterField}><span>Data da filtrare</span>
                                    <select value={filters.date_field} onChange={event => { setPage(0); setFilters({ ...filters, date_field: event.target.value }); }}>
                                        <option value="created_at">Data di creazione</option>
                                        <option value="sent_at">Data di invio</option>
                                        <option value="scheduled_for">Data di programmazione</option>
                                    </select>
                                </label>
                                <label className={styles.filterField}><span>Dal</span><input type="date" value={filters.date_from} max={filters.date_to || '9999-12-30'} onChange={event => { setPage(0); setFilters({ ...filters, date_from: event.target.value }); }} /></label>
                                <label className={styles.filterField}><span>Al</span><input type="date" value={filters.date_to} min={filters.date_from || undefined} max="9999-12-30" onChange={event => { setPage(0); setFilters({ ...filters, date_to: event.target.value }); }} /></label>
                                <div className={styles.filterField}><span>Giorni inclusi · fuso orario italiano</span><Button appearance="subtle" disabled={!filters.date_from && !filters.date_to} onClick={() => { setPage(0); setFilters({ ...filters, date_from: '', date_to: '' }); }}>Azzera date</Button></div>
                                {filters.date_from && filters.date_to && filters.date_from > filters.date_to && <p role="alert" className={styles.dateError}>La data iniziale deve precedere o coincidere con quella finale.</p>}
                            </div>
                            {loadError && <div className={styles.error} role="alert">{loadError}<Button appearance="subtle" onClick={getMailings}>Riprova</Button></div>}
                            <Table appearance="minimal" loading={loading} loadingN={8}
                                style={{ border: 0, borderRadius: 0, boxShadow: 'none', marginTop: 0 }}
                                defaultSort={{ key: 'created_at', direction: 'desc' }}
                                columns={[
                                    { key: 'subject', label: 'Titolo', type: 'custom', wrap: true, handleClick: true },
                                    { key: 'recipient', label: 'Destinatario', type: 'custom', handleClick: true },
                                    { key: 'type', label: 'Tipo', type: 'string', wrap: true },
                                    { key: 'created_at', label: 'Data di creazione', type: 'custom' },
                                    { key: 'sent_at', label: 'Data di invio', type: 'custom' },
                                    { key: 'scheduled_for', label: 'Invio programmato', type: 'custom' },
                                    { key: 'status', label: 'Stato', type: 'custom' },
                                    { key: 'actions', label: 'Azioni', type: 'custom', handleClick: true },
                                ]} elements={rows} />
                            {!loading && !loadError && mailings.length === 0 && <EmptyContent title="Nessuna mail trovata" message="Non ci sono mail corrispondenti ai filtri selezionati." />}
                            <div className={styles.pagination}><Pagination group={width > 540 ? 5 : 0} total={count} per={per} page={page} onChange={setPage} loading={loading} /></div>
                        </Card>
                    </div>
                </div>
            </div>
            <AlertDialog dialogProps={{ appearance: "modern" }} open={sendingMail} title="Inviare la mail?" text="Sei sicuro di voler inviare la mail? Questa operazione non può essere annullata." onClose={() => {
                setSendingMail(null)
            }}
                actions={[
                    {
                        label: 'INVIA',
                        onClick: async () => {
                            await sendEmail(sendingMail.id)
                            setSendingMail(null)
                        }
                    }
                ]}
            />

            <AlertDialog dialogProps={{ appearance: "modern" }} open={cancellingMail} title="Annullare l'invio della mail?" text="Sei sicuro di voler annullare l'invio della mail?" onClose={() => {
                setCancellingMail(null)
            }}
                actions={[
                    {
                        label: 'ANNULLA INVIO',
                        onClick: async () => {
                            await cancelMail(cancellingMail.id)
                            setCancellingMail(null)
                        }
                    }
                ]}
            />
            <AlertDialog dialogProps={{ appearance: "modern" }} open={deletingMail} title="Eliminare la mail?" text="Sei sicuro di voler eliminare la mail? Questa operazione non può essere annullata." onClose={() => {
                setDeletingMail(null)
            }}
                actions={[
                    {
                        label: 'ELIMINA',
                        onClick: async () => {
                            await deleteEmail(deletingMail.id)
                            setDeletingMail(null)
                        }
                    }
                ]}
            />

            <Dialog
                appearance="modern"
                open={viewMailContent}
                title={viewMailContent?.subject ?? 'Contenuto della mail'}
                style={{ width: '80vw', maxWidth: '900px' }}
                contentMaxHeight="70vh"
                overflow="hidden"
                onClose={() => {
                    setViewMailContent(null)
                }}
            >
                <iframe
                    title={viewMailContent?.subject ?? 'Contenuto della mail'}
                    srcDoc={viewMailContent?.content ?? ''}
                    sandbox=""
                    style={{ width: '100%', height: '65vh', border: 0, background: '#f4f4f4' }}
                />
            </Dialog>

            <Dialog appearance="modern" open={reschedulingMail} title="Riprogramma mail" onClose={() => {
                setReschedulingMail(null)
            }}
                action={
                    <Button onClick={() => {
                        rescheduleEmail(reschedulingMail)
                        setReschedulingMail(null)
                    }}>RIPROGRAMMA</Button>
                }>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', minHeight: '400px', width: '100%' }}>
                    <TextInput
                        appearance="modern"
                        type="date"
                        value={null}
                        defaultValue={null}
                        placeholder="Riprogramma al"
                        min={new Date()}
                        onKeyUp={(d) => {
                            setReschedulingMail((prev) => {
                                prev.reschedule_date = d.toISOString().split('.')[0]
                                return { ...prev }
                            })
                        }}
                    />
                    <div>
                        Seleziona una data per riprogrammare l'invio della mail.
                    </div>
                    <div className={styles.spacer}></div>
                </div>
            </Dialog>
        </HeaderFooterLayout >
    )
}

export default Mailings;
